var _style, _g, _ellipse, _ellipse2, _line, _line2, _line3, _line4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOmgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.336 38.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .omg-logo {\n      fill: #686868;\n    }\n\n    .bus {\n      stroke: #686868;\n      fill: none;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      stroke-width: 3px;\n    }\n\n  .bus-omg {\n    animation: bounce 0.2s ease-in-out infinite alternate;\n  }\n  @keyframes bounce {\n    0%   { transform: translateY(-1%) }\n    100% { transform: translateY(3%) }\n  }\n\n  .zoom-line {\n    transform-origin: center right;\n    stroke-dasharray: 22;\n    animation: line .5s ease-in-out infinite alternate;\n    animation-fill-mode: both;\n  }\n\n  .zoom-line-1 { animation-delay: 0.0s }\n  .zoom-line-2 { animation-delay: 0.2s }\n  .zoom-line-3 { animation-delay: 0.4s }\n  .zoom-line-3 { animation-delay: 0.6s }\n\n  @keyframes line {\n    0%   { stroke-dashoffset: 0 }\n    100% { stroke-dashoffset: 20 }\n  }\n\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bus-omg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "omg-logo",
    d: "M79.505,20.066a3.157,3.157,0,0,0-2.53,1.142,4.491,4.491,0,0,0-.9,2.877,4.48,4.48,0,0,0,.9,2.876,3.37,3.37,0,0,0,5.059,0,4.488,4.488,0,0,0,.9-2.876,4.489,4.489,0,0,0-.9-2.877A3.156,3.156,0,0,0,79.505,20.066Zm1.056,5.52a1.29,1.29,0,0,1-2.112,0,2.8,2.8,0,0,1-.351-1.5,2.8,2.8,0,0,1,.351-1.5,1.291,1.291,0,0,1,2.112,0,2.8,2.8,0,0,1,.348,1.5A2.787,2.787,0,0,1,80.561,25.586Zm10.4-1.95c-.086.19-.174.4-.255.6-.084-.2-.174-.417-.261-.6l-1.59-3.452H87.018v7.808h1.948V25.053c0-.075,0-.171,0-.274l1.71,3.744,1.71-3.744c0,.1,0,.2,0,.274v2.936h1.98V20.18H92.5Zm10.992.053v1.885h1.081a.8.8,0,0,1-.208.335,1.282,1.282,0,0,1-.883.249,1.244,1.244,0,0,1-1.062-.553,3.048,3.048,0,0,1,0-3.031,1.235,1.235,0,0,1,1.058-.54,1.126,1.126,0,0,1,.731.215,1.656,1.656,0,0,1,.43.588l.108.217,1.853-.765-.1-.242A3.285,3.285,0,0,0,103.86,20.6a3.194,3.194,0,0,0-1.91-.537A3.267,3.267,0,0,0,99.419,21.2a4.36,4.36,0,0,0-.967,2.881A4.4,4.4,0,0,0,99.393,27a3.442,3.442,0,0,0,4.781.27,3.169,3.169,0,0,0,.909-2.359V23.689Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bus bus-frame",
    d: "M122.97,31.347H60.186m-12.625,0H38.808c-2.6,0-3.688-.919-3.688-4.67l.461-24.372c2.613-.445,108.562-.337,111.144.237l5.291,15c2.681,4.643,3.073,13.8-.078,13.8H134.925M36.133,17H151.154"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "bus bus-tire bus-tire-1",
    cx: 53.905,
    cy: 31.05,
    rx: 5.655,
    ry: 5.562
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "bus bus-tire bus-tire-2",
    cx: 128.924,
    cy: 31.05,
    rx: 5.655,
    ry: 5.562
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "bus zoom-line zoom-line-1",
    x1: 29.094,
    y1: 6.22,
    x2: 5.094,
    y2: 6.22
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "bus zoom-line zoom-line-2",
    x1: 29.094,
    y1: 13.792,
    x2: 5.094,
    y2: 13.792
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "bus zoom-line zoom-line-3",
    x1: 29.094,
    y1: 21.365,
    x2: 5.094,
    y2: 21.365
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "bus zoom-line zoom-line-4",
    x1: 29.094,
    y1: 28.938,
    x2: 5.094,
    y2: 28.938
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmgLoading);
export default __webpack_public_path__ + "static/media/omg-loading.1e47aa0c5dbcc0dc763fc44656fba8f7.svg";
export { ForwardRef as ReactComponent };